import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useToggle, useUpdateEffect, useWindowSize } from "react-use";

import { apiRequest } from "services/api/api";
import {
  updateUsers,
  updateUsersTop,
  updateUsersWork,
} from "store/slices/users";

import RectanglesChart from "./charts/RectanglesChart";
import Options from "./ui/Options";

function App() {
  const dispatch = useDispatch();
  const [data, updateData] = useState({
    from: null,
    to: null,
    showByTimeInterval: null,
    users: [],
  });
  const [usersReceived, toggleUsersReceived] = useToggle();
  const [loading, toggleLoading] = useToggle(true);
  const windowDimensions = useWindowSize();

  useEffect(() => {
    apiRequest("v1/users", { active: true })
      .then(({ data }) => dispatch(updateUsers(data.data)))
      .then(() =>
        apiRequest("v2/moderator_ban_summaries", {
          month_offset: 0,
          group: ["default"],
          role: ["moderator"],
        })
      )
      .then(({ data }) => dispatch(updateUsersTop(data.data)))
      .then(() =>
        apiRequest("v2/moderator_ban_summaries", {
          month_offset: 0,
          group: ["anton"],
          role: ["moderator"],
        })
      )
      .then(({ data }) => dispatch(updateUsersTop(data.data)))
      .then(() =>
        apiRequest("v2/moderator_ban_summaries", {
          month_offset: 0,
          group: ["default", "anton"],
          role: ["report_moderator"],
        })
      )
      .then(({ data }) => dispatch(updateUsersTop(data.data)))
      .then(() =>
        apiRequest("v2/moderator_ban_summaries", {
          month_offset: 0,
          group: ["default", "anton"],
          role: ["text_moderator"],
        })
      )
      .then(({ data }) => dispatch(updateUsersTop(data.data)))
      .then(() =>
        apiRequest("v2/moderator_ban_summaries", {
          month_offset: 0,
          group: ["default"],
          role: ["supermoderator", "admin"],
        })
      )
      .then(({ data }) => dispatch(updateUsersTop(data.data)))
      .then(() =>
        apiRequest("v2/moderator_ban_summaries", {
          month_offset: 0,
          group: ["anton"],
          role: ["midfinger_moderator"],
        })
      )
      .then(({ data }) => dispatch(updateUsersTop(data.data)))
      .then(() => toggleUsersReceived());
  }, [dispatch, toggleUsersReceived]);

  useUpdateEffect(() => {
    if (usersReceived) {
      toggleLoading(true);

      apiRequest("v1/moderator_ban_summaries", {
        from: data.from,
        till: data.to,
        group_by: data.showByTimeInterval,
      }).then(({ data }) => {
        dispatch(updateUsersWork(data.data));
        toggleLoading(false);
      });
    }
  }, [data.from, data.to, data.showByTimeInterval, usersReceived]);

  return (
    <div>
      <main>
        <Options updateData={updateData} />
        <RectanglesChart
          loading={loading}
          data={data}
          dimensions={windowDimensions}
        />
      </main>
    </div>
  );
}

export default App;
